const carriers = [
  "Progressive", "Travelers", "Hartford", "Nationwide",
  "Liberty Mutual", "Safeco", "Chubb", "Employers",
  "Guard", "Westfield", "Selective", "AmTrust",
];

const CarrierLogos = () => {
  return (
    <section className="py-12 md:py-16 border-y border-border">
      <div className="container">
        <p className="text-center text-sm text-muted-foreground mb-8 font-medium uppercase tracking-wider">
          We Shop 30+ Top-Rated Carriers For You
        </p>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-6 md:gap-8 items-center justify-items-center">
          {carriers.map((name) => (
            <div
              key={name}
              className="flex items-center justify-center h-12 px-4 rounded-lg text-muted-foreground font-semibold text-sm hover:text-foreground transition-colors"
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarrierLogos;
